"use strict";
import { ChainId } from "@uniswap/sdk-core";
export const FACTORY_ADDRESS = "0x1F98431c8aD98523631AE4a59f267346ea31F984";
export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
export const POOL_INIT_CODE_HASH = "0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54";
export function poolInitCodeHash(chainId) {
  switch (chainId) {
    case ChainId.ZKSYNC:
      return "0x010013f177ea1fcbc4520f9a3ca7cd2d1d77959e05aa66484027cb38e712aeed";
    case 97:
    // BSC testnet
    case 56:
      return POOL_INIT_CODE_HASH;
    default:
      return POOL_INIT_CODE_HASH;
  }
}
export var FeeAmount = /* @__PURE__ */ ((FeeAmount2) => {
  FeeAmount2[FeeAmount2["LOWEST"] = 100] = "LOWEST";
  FeeAmount2[FeeAmount2["LOW_200"] = 200] = "LOW_200";
  FeeAmount2[FeeAmount2["LOW_300"] = 300] = "LOW_300";
  FeeAmount2[FeeAmount2["LOW_400"] = 400] = "LOW_400";
  FeeAmount2[FeeAmount2["LOW_500"] = 500] = "LOW_500";
  FeeAmount2[FeeAmount2["LOW"] = 1e3] = "LOW";
  FeeAmount2[FeeAmount2["MEDIUM"] = 3e3] = "MEDIUM";
  FeeAmount2[FeeAmount2["HIGH"] = 1e4] = "HIGH";
  return FeeAmount2;
})(FeeAmount || {});
export const TICK_SPACINGS = {
  [100 /* LOWEST */]: 1,
  // 0.01% -> tick spacing 1
  [200 /* LOW_200 */]: 20,
  // 0.02% -> tick spacing 20 (non-standard, Base-only)
  [300 /* LOW_300 */]: 30,
  // 0.03% -> tick spacing 30 (non-standard, Base-only)
  [400 /* LOW_400 */]: 40,
  // 0.04% -> tick spacing 40 (non-standard, Base-only)
  [500 /* LOW_500 */]: 50,
  // 0.05% -> tick spacing 50
  [1e3 /* LOW */]: 100,
  // 0.1% -> tick spacing 100
  [3e3 /* MEDIUM */]: 200,
  // 0.3% -> tick spacing 200
  [1e4 /* HIGH */]: 2e3
  // 1% -> tick spacing 2000
};
